import { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import { getReportRangeErrorMessage } from "src/utils/report/reportRange.util";

import { CardLayout, MTable } from "../v3";
import { materialReportColumns } from "../../pages/report/constants";
import { get_date } from "../generalComponets";
import { AnalyticsService } from "../../services";
import { downloadFile } from "../../utils/download.utils";

export const MaterialReportResults = ({
  reportType,
  data = {},
  loading = false,
  paginationState,
  handlePaginationChange = () => {},
  showExportButton = false,
  reportFilters = {},
}) => {
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [pdfSuccess, setPdfSuccess] = useState(false);
  const [prevFilters, setPrevFilters] = useState({});

  useEffect(() => {
    if (pdfSuccess && JSON.stringify(reportFilters) !== JSON.stringify(prevFilters)) {
      setPdfSuccess(false);
    }
  }, [reportFilters, prevFilters, pdfSuccess]);

  const handleDownloadPdfClick = async () => {
    setIsPdfGenerating(true);
    setPdfSuccess(false);
    try {
      const response = await AnalyticsService.downloadMaterialReportPdf(reportFilters || {});

      const currentDateTime = moment().format("YYYYMMDD-HHmmss");
      const filename = `material-report-${reportType}-${currentDateTime}.pdf`;

      downloadFile(response.data, filename);
      toast.success("Report downloaded successfully");

      setPdfSuccess(true);
      setPrevFilters(reportFilters);
    } catch (error) {
      console.error("Report download failed:", error);
      toast.error((await getReportRangeErrorMessage(error)) ?? "Failed to download report");
    } finally {
      setIsPdfGenerating(false);
    }
  };
  const rows =
    data?.rows?.map((row, index) => ({
      id: index + 1 + paginationState.page * paginationState.pageSize,
      sl: index + 1 + paginationState.page * paginationState.pageSize,
      formattedDate: get_date(row.date),
      ...row,
    })) || [];

  const totalQuantity = rows.reduce((sum, row) => sum + Number(row.quantity || 0), 0);
  const totalPurchaseAmount = rows.reduce((sum, row) => sum + Number(row.totalPurchase || 0), 0);
  const totalPrice = rows.reduce((sum, row) => sum + Number(row.total || 0), 0);

  const subtotal =
    data?.count > 0
      ? [
          {
            id: "subtotal",
            label: "Subtotal",
            totalQuantity: totalQuantity.toFixed(2),
            totalPurchaseAmount: totalPurchaseAmount.toFixed(2),
            totalPrice: totalPrice.toFixed(2),
          },
        ]
      : [];

  const allRows = [...rows, ...subtotal];
  return (
    <CardLayout>
      <MTable
        // Export data
        showExportButton={showExportButton}
        isPdfGenerating={isPdfGenerating}
        pdfSuccess={pdfSuccess}
        currentFilters={reportFilters}
        prevFilters={prevFilters}
        onExportPdfClick={handleDownloadPdfClick}
        // Table data
        columnHeaders={materialReportColumns[reportType]}
        tableRows={allRows}
        rowCount={data.count}
        loading={loading}
        paginationModel={paginationState}
        onPaginationChange={handlePaginationChange}
      />
    </CardLayout>
  );
};
